var _path, _rect, _rect2, _rect3, _path2, _rect4, _path3, _path4, _ellipse, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMulticastinline = function SvgMulticastinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81,
    height: 81,
    fill: "none",
    viewBox: "0 0 81 81"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#D1D7E0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M43.353 16.667V40M67.824 33.333v20.834M18.882 33.333V52.5M54.647 12.5h12.177a1 1 0 0 1 1 1v9.833M32.059 12.5H19.882a1 1 0 0 0-1 1v9.833"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 30.118,
    x: 58.412,
    y: 7.5,
    fill: "#D6EBFF",
    stroke: "#00877C",
    strokeLinejoin: "round",
    strokeWidth: 2,
    rx: 1,
    transform: "rotate(90 58.412 7.5)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 20.706,
    x: 29.235,
    y: 23.333,
    stroke: "#A7B1BE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    rx: 1,
    transform: "rotate(90 29.235 23.333)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 20.706,
    x: 53.706,
    y: 37.5,
    fill: "#FFF5D6",
    stroke: "#6B91C7",
    strokeLinejoin: "round",
    strokeWidth: 2,
    rx: 1,
    transform: "rotate(90 53.706 37.5)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFBF00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M39.588 42.5h7.53"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 20.706,
    x: 78.177,
    y: 23.333,
    stroke: "#E83030",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    rx: 1,
    transform: "rotate(90 78.177 23.333)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#A7B1BE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M15.118 28.333h7.53M64.059 28.333h7.53"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0073E6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M34.882 12.5h16.942"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.824,
    cy: 54.167,
    fill: "#D6FFFC",
    stroke: "#00877C",
    strokeLinejoin: "round",
    strokeWidth: 2,
    rx: 5.647,
    ry: 5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D1D7E0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M16.447 53.333c3.96-.01 7.774 1.287 10.662 3.626 2.888 2.339 4.63 5.542 4.87 8.954a9.659 9.659 0 0 1 3.63-.436 9.412 9.412 0 0 1 3.5.936 8.113 8.113 0 0 1 2.71 2.13 6.773 6.773 0 0 1 1.406 2.92 6.31 6.31 0 0 1-.164 3.161 7 7 0 0 1-1.703 2.801 8.419 8.419 0 0 1-2.919 1.913 9.574 9.574 0 0 1-3.584.662H16.447c-4.097 0-8.026-1.405-10.923-3.906C2.627 73.595 1 70.203 1 66.667c0-3.537 1.627-6.928 4.524-9.428 2.897-2.5 6.826-3.906 10.923-3.906"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#D6FFFC",
    d: "M9.47 62.917v7.343c0 1.468 3.16 2.656 7.059 2.656s7.058-1.188 7.058-2.656v-7.343"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#00877C",
    strokeWidth: 2,
    d: "M9.47 62.917v7.343c0 1.468 3.16 2.656 7.059 2.656s7.058-1.188 7.058-2.656v-7.343"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#D6FFFC",
    stroke: "#00877C",
    strokeWidth: 2,
    d: "M16.529 65.416c3.898 0 7.058-1.119 7.058-2.5 0-1.38-3.16-2.5-7.058-2.5-3.898 0-7.058 1.12-7.058 2.5 0 1.381 3.16 2.5 7.058 2.5Z"
  })));
};
export default SvgMulticastinline;